import { render, staticRenderFns } from "./base_text_tabs.vue?vue&type=template&id=3c26e775&scoped=true&"
import script from "./base_text_tabs.vue?vue&type=script&lang=ts&"
export * from "./base_text_tabs.vue?vue&type=script&lang=ts&"
import style0 from "./base_text_tabs.vue?vue&type=style&index=0&id=3c26e775&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c26e775",
  null
  
)

export default component.exports